
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fsvOM", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=pt-BR.900e18e5.js.map
